<template>
  <div class="common-layout">
    <el-container>
      <el-header class="header">
        <div class="header-logo">
          <img style="height: 80%" :src="logoUrl" alt="logo" />
          <div class="header-title">{{ systemTitle }}</div>
        </div>
        <div class="header-content">
          <span
            class="header-menu-item"
            @click="router.push('/overview-dataStatistics')"
            >电子屏安全管理</span
          >
          <!-- <span
            class="header-menu-item"
            @click="router.push({ name: 'SecurityMap' })"
            >电子屏安全态势</span
          > -->

          <el-dropdown @command="handleCommand" class="user-dropdown">
            <div class="user-info">
              <el-avatar :size="32" class="user-avatar">
                <el-icon><User /></el-icon>
              </el-avatar>
              <span class="user-name">{{ userName }}</span>
              <el-icon class="dropdown-icon"><ArrowDown /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="changePassword">
                  <el-icon><Lock /></el-icon>
                  <span>修改密码</span>
                </el-dropdown-item>
                <el-dropdown-item command="switchAccount" divided>
                  <el-icon><Switch /></el-icon>
                  <span>切换账号</span>
                </el-dropdown-item>
                <el-dropdown-item command="logout" divided>
                  <el-icon><CircleClose /></el-icon>
                  <span>退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 账号选择弹窗 -->
      <el-dialog
        v-model="accountDialogVisible"
        title="切换账号"
        width="400px"
        :close-on-click-modal="false"
      >
        <div class="account-list">
          <div
            v-for="account in accountList"
            :key="account.phone"
            class="account-item"
          >
            <div class="account-info" @click="selectAccount(account)">
              <el-avatar :size="40" class="account-avatar">
                <el-icon><User /></el-icon>
              </el-avatar>
              <div class="account-details">
                <div class="account-name">
                  {{ account.name || account.phone }}
                </div>
                <div class="account-phone">{{ account.phone }}</div>
              </div>
            </div>
            <div class="account-actions-item">
              <el-tooltip content="删除账号" placement="top" :show-after="300">
                <el-icon
                  class="account-delete"
                  @click.stop="removeAccount(account.phone)"
                >
                  <Delete />
                </el-icon>
              </el-tooltip>
              <el-icon class="account-arrow"><ArrowRight /></el-icon>
            </div>
          </div>
          <div v-if="accountList.length === 0" class="empty-account">
            <el-icon><UserFilled /></el-icon>
            <p>暂无历史账号</p>
          </div>
        </div>
        <div class="account-actions">
          <el-button @click="accountDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="goToLogin">
            <el-icon><Plus /></el-icon>
            使用其他账号登录
          </el-button>
        </div>
      </el-dialog>
      <el-container class="container">
        <el-aside width="240px" class="aside">
          <el-menu
            class="side-menu"
            active-text-color="#1890ff"
            background-color="#fff"
            :default-active="activeIndex"
            text-color="#333"
            :router="true"
            @select="selectMenu"
          >
            <el-sub-menu index="overview">
              <template #title>
                <el-icon class="menu-icon">
                  <Message />
                </el-icon>
                <span>概览</span>
              </template>
              <template v-for="item in overviewMap" :key="item.value">
                <el-menu-item
                  v-if="item.visible"
                  :index="item.value"
                  class="menu-item"
                >
                  {{ item.label }}
                </el-menu-item>
              </template>
            </el-sub-menu>
            <el-sub-menu index="upload">
              <template #title>
                <el-icon class="menu-icon">
                  <Message />
                </el-icon>
                <span>上传内容</span>
              </template>
              <template v-for="item in uoloadMap" :key="item.value">
                <el-menu-item
                  v-if="item.visible"
                  :index="item.value"
                  class="menu-item"
                >
                  {{ item.label }}
                </el-menu-item>
              </template>
            </el-sub-menu>
            <el-sub-menu index="management">
              <template #title>
                <el-icon class="menu-icon">
                  <Message />
                </el-icon>
                <span>管理模块</span>
              </template>
              <template v-for="item in managementMap" :key="item.value">
                <el-menu-item
                  v-if="item.visible"
                  :index="item.value"
                  class="menu-item"
                >
                  {{ item.label }}
                </el-menu-item>
              </template>
            </el-sub-menu>
          </el-menu>
        </el-aside>
        <el-main class="main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>

    <!-- 修改密码弹窗 -->
    <ChangePasswordDialog
      v-if="showChangePasswordDialog"
      :visible="showChangePasswordDialog"
      @update:visible="showChangePasswordDialog = $event"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { getSystemConfig } from "@/utils/index";

import {
  User,
  ArrowDown,
  Switch,
  CircleClose,
  ArrowRight,
  UserFilled,
  Plus,
  Delete,
  Lock,
} from "@element-plus/icons-vue";
import {
  getUserInfo as getUserInfoFromStorage,
  removeUserInfo,
  getAccountList,
  removeAccountFromList,
  updateAccountInList,
} from "../utils/";
import { getUserInfo as getUserInfoApi } from "../api";
import ChangePasswordDialog from "@/views/components/ChangePasswordDialog.vue";
const router = useRouter();
const route = useRoute();
const selectMenu = (index: string) => {
  router.push(index);
};

const {
  systemTitle,
  images: { logoUrl },
} = getSystemConfig();

// 存储从接口获取的用户信息
const userInfoData = ref<{ name?: string; phone?: string }>({});

// 账号列表相关
const accountDialogVisible = ref(false);
const accountList = ref<
  Array<{
    phone: string;
    name?: string;
    role?: string;
    lastLoginTime: number;
  }>
>([]);

// 修改密码弹窗
const showChangePasswordDialog = ref(false);

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const res = await getUserInfoApi();
    if (res?.code === "success" && res.content) {
      const userInfo = res.content as { name?: string; phone?: string };
      userInfoData.value = userInfo;

      // 如果获取到了 phone 和 name，更新账号列表中的 name
      if (userInfo.phone && userInfo.name) {
        updateAccountInList(userInfo.phone, { name: userInfo.name });
        // 如果账号列表已加载，同步更新本地状态
        if (accountList.value.length > 0) {
          loadAccountList();
        }
      }
    }
  } catch (error) {
    console.error("获取用户信息失败:", error);
  }
};

// 加载账号列表
const loadAccountList = () => {
  accountList.value = getAccountList();
};

// 获取用户名，优先显示 name，如果没有则显示 phone，都没有则显示"用户"
const userName = computed(() => {
  return userInfoData.value?.name || userInfoData.value?.phone || "用户";
});

// 组件挂载时获取用户信息和账号列表
onMounted(() => {
  fetchUserInfo();
  loadAccountList();
});

// 处理下拉菜单命令
const handleCommand = (command: string) => {
  if (command === "logout") {
    removeUserInfo();
    router.push("/login");
    ElMessage({
      message: "退出登录成功",
      type: "success",
    });
  } else if (command === "switchAccount") {
    // 打开账号选择弹窗
    loadAccountList();
    accountDialogVisible.value = true;
  } else if (command === "changePassword") {
    // 打开修改密码弹窗
    showChangePasswordDialog.value = true;
  }
};

// 选择账号
const selectAccount = (account: {
  phone: string;
  name?: string;
  role?: string;
}) => {
  accountDialogVisible.value = false;
  // 跳转到登录页，并传递账号信息
  router.push({
    path: "/login",
    query: {
      phone: account.phone,
      name: account.name || "",
    },
  });
};

// 跳转到登录页（使用其他账号登录）
const goToLogin = () => {
  accountDialogVisible.value = false;

  router.push({
    path: "/login",
    query: {},
  });
};

// 删除账号
const removeAccount = (phone: string) => {
  ElMessageBox.confirm("确定要删除该账号吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      removeAccountFromList(phone);
      loadAccountList();
      ElMessage({
        message: "删除成功",
        type: "success",
      });
    })
    .catch(() => {
      // 用户取消删除
    });
};

const isSuperAdmin = computed(
  () => getUserInfoFromStorage().role === "superadmin"
);
const isAdmin = computed(() => getUserInfoFromStorage().role === "admin");
const isUser = computed(() => getUserInfoFromStorage().role === "user");

const activeIndex = computed(() => route.path);

const uoloadMap = [
  {
    label: "图片上传",
    value: "/upload-img",
    visible: true,
  },
  {
    label: "文本上传",
    value: "/upload-text",
    visible: true,
  },
  {
    label: "视频上传",
    value: "/upload-video",
    visible: true,
  },
];
const overviewMap = [
  {
    label: "数据统计",
    value: "/overview-dataStatistics",
    visible: isSuperAdmin.value || isAdmin.value,
  },
  {
    label: "上传日志",
    value: "/overview-auditLog",
    visible: isSuperAdmin.value || isAdmin.value || isUser.value,
  },
];
const managementMap = [
  {
    label: "用户管理",
    value: "/userManagement",
    visible: isSuperAdmin.value,
  },
  {
    label: "设备在线管理",
    value: "/equipmentManagement",
    visible: isSuperAdmin.value || isAdmin.value,
  },
  {
    label: "策略管理",
    value: "/policyManagement",
    visible: isSuperAdmin.value || isAdmin.value,
  },
  {
    label: "个人信息",
    value: "personalInfoManagement",
    visible: isSuperAdmin.value || isAdmin.value || isUser.value,
  },
];
</script>
<style lang="scss" scoped>
.header {
  height: 130px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  &-logo {
    padding: 0 40px;
    height: 70px;
    display: flex;
    align-items: center;
    background: #fff;
  }

  &-title {
    margin-left: 40px;
    font-size: 20px;
    font-weight: 600;
    color: #1f2329;
    letter-spacing: 1px;
  }

  &-content {
    height: 60px;
    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
    display: flex;
    align-items: center;
  }

  &-menu-item {
    margin-left: 40px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s;
    padding: 8px 16px;
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}

.user-dropdown {
  margin-left: auto;
  margin-right: 40px;
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 20px;
  transition: all 0.3s;
  color: #fff;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.user-avatar {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  flex-shrink: 0;
}

.user-name {
  font-size: 14px;
  color: #fff;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-icon {
  font-size: 12px;
  color: #fff;
  transition: transform 0.3s;
  flex-shrink: 0;
}

.user-dropdown.is-opened .dropdown-icon {
  transform: rotate(180deg);
}

:deep(.el-dropdown-menu__item) {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;

  .el-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }

  span {
    flex: 1;
  }
}

.container {
  height: calc(100vh - 130px);
  background: #f5f7fa;

  .aside {
    height: 100%;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.06);
    background: #fff;
  }

  .main {
    height: 100%;
    padding: 24px;
  }
}

.side-menu {
  border-right: none;
  padding: 16px 0;
}

.menu-icon {
  font-size: 18px;
  color: #2c3e50;
  margin-right: 12px;
}

.menu-item {
  height: 48px;
  line-height: 48px;
  margin: 4px 0;

  &:hover {
    color: #2c3e50;
    background: #ecf0f1;
  }
}

.el-menu-item.is-active {
  background: #ecf0f1;
  border-right: 3px solid #2c3e50;
  font-weight: 500;
}

:deep(.el-sub-menu__title) {
  height: 48px;
  line-height: 48px;

  &:hover {
    background: #f5f7fa;
  }
}

// 账号选择弹窗样式
.account-list {
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 20px;

  .account-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    margin-bottom: 8px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: #f5f7fa;
      border-color: #409eff;
    }

    .account-info {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;

      .account-avatar {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
      }

      .account-details {
        flex: 1;

        .account-name {
          font-size: 14px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 4px;
        }

        .account-phone {
          font-size: 12px;
          color: #909399;
        }
      }
    }

    .account-actions-item {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;
    }

    .account-delete {
      font-size: 16px;
      color: #fa0a0a;
      cursor: pointer;
      padding: 6px 8px;
      border-radius: 6px;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      opacity: 0.6;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: 6px;
        background: transparent;
        transition: background 0.25s ease;
      }

      &:hover {
        color: #f56c6c;
        opacity: 1;
        transform: translateY(-1px) scale(1.1);

        &::before {
          background: rgba(245, 108, 108, 0.1);
        }
      }

      &:active {
        transform: translateY(0) scale(1.05);
        color: #f56c6c;

        &::before {
          background: rgba(245, 108, 108, 0.15);
        }
      }
    }

    .account-arrow {
      color: #c0c4cc;
      font-size: 16px;
      transition: color 0.3s;
    }

    &:hover {
      .account-arrow {
        color: #409eff;
      }
    }
  }

  .empty-account {
    text-align: center;
    padding: 40px 20px;
    color: #909399;

    .el-icon {
      font-size: 48px;
      margin-bottom: 16px;
      color: #c0c4cc;
    }

    p {
      margin: 0;
      font-size: 14px;
    }
  }
}

.account-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e4e7ed;

  .el-button {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
</style>
